import React from 'react'
import styles from './Showcase.module.scss'

export const Showcase = ({image}) => (
  <div className={styles.container}>
    <img className={styles.screen} src={image} alt="" />
  </div>
)
